let BaseUrl = '/api/';
let CommonUrl = BaseUrl + 'Common/';
let MainUrl = BaseUrl + 'Main/';
let OrganizationUrl = BaseUrl + 'Organization/';
let RoleUrl = BaseUrl + 'Role/';
let UserUrl = BaseUrl + 'User/';
let BizParamSettingUrl = BaseUrl + 'BizParamSetting/';
let CodeFormatUrl = BaseUrl + 'CodeFormat/';
let SalesUrl = BaseUrl + 'Sales/';
let AttributeRuleUrl = BaseUrl + 'AttributeRule/';
let CompanyUrl = BaseUrl + 'Company/';
let BlackListUrl = BaseUrl + 'BlackList/';
let ProductMergeUrl = BaseUrl + 'ProductMerge/';
let CustomerUrl = BaseUrl + 'Customer/';
let VendorUrl = BaseUrl + 'Vendor/';
let ProductUrl = BaseUrl + 'Product/';
let ApplyProductUrl = BaseUrl + 'ApplyProduct/';
let AccountUrl = BaseUrl + 'Account/';
let OnlineVendorUrl = BaseUrl + 'OnlineVendor/';
let OnlineProductUrl = BaseUrl + 'OnlineProduct/';
let AgentUrl = BaseUrl + 'Agent/';
let MemberUrl = BaseUrl + 'Member/';
let OnlineOrderUrl = BaseUrl + 'OnlineOrder/';
let ApplyAllocationUrl = BaseUrl + 'ApplyAllocation/';
let ApplyOrderUrl = BaseUrl + 'ApplyOrder/';
let ApplyMemberUrl = BaseUrl + 'ApplyMember/';
let InquiryMemberUrl = BaseUrl + 'InquiryMember/';
let ApplyConsumeUrl = BaseUrl + 'ApplyConsume/';
let ApplyEmailUrl = BaseUrl + 'ApplyEmail/';
let YearOrderUrl = BaseUrl + 'YearOrder/';
let YearOrderSettleUrl = BaseUrl + 'YearOrderSettle/';
let InquiryOrderUrl = BaseUrl + 'InquiryOrder/';
let ComparisonMemberUrl = BaseUrl + 'ComparisonMember/';
let ComparisonProductUrl = BaseUrl + 'ComparisonProduct/';
let OnlineComparisonProductUrl = BaseUrl + 'OnlineComparisonProduct/';
let ComparisonProductNoticeUrl = BaseUrl + 'ComparisonProductNotice/';

const URL = {
    Common: {
        ImportExcel: CommonUrl + "ImportExcel",
        ExportExcel: CommonUrl + "ExportExcel",
        UpLoadFile: CommonUrl + "UpLoadFile",
        DownLoadFile: CommonUrl + "DownLoadFile",
        HttpDownLoadFile: CommonUrl + "HttpDownLoadFile",
    },
    Main: {
        UserLogin: MainUrl + 'UserLogin',
        LoginOut: MainUrl + 'LoginOut',
        LoadMenu: MainUrl + 'LoadMenu',
    },
    Organization: {
        GetOrganizationList: OrganizationUrl + 'GetOrganizationList',
        GetOrganization: OrganizationUrl + 'GetOrganization',
        SaveOrganization: OrganizationUrl + 'SaveOrganization',
        DeleteOrganization: OrganizationUrl + 'DeleteOrganization'
    },
    Role: {
        GetRoleList: RoleUrl + 'GetRoleList',
        GetRole: RoleUrl + 'GetRole',
        SaveRole: RoleUrl + 'SaveRole',
        DeleteRole: RoleUrl + 'DeleteRole',
        GetRoleFunctionalityList: RoleUrl + 'GetRoleFunctionalityList',
        SaveRoleFunctionality: RoleUrl + 'SaveRoleFunctionality',
    },
    User: {
        GetUserList: UserUrl + 'GetUserList',
        GetAdminUserList: UserUrl + 'GetAdminUserList',
        GetUser: UserUrl + 'GetUser',
        SaveUser: UserUrl + 'SaveUser',
        DeleteUser: UserUrl + 'DeleteUser',
        SetActiveUser: UserUrl + 'SetActiveUser',
        SetAdminUser: UserUrl + 'SetAdminUser',
        GetUserListByNameAccount: UserUrl + 'GetUserListByNameAccount',
        GetUserFunctionalityList: UserUrl + 'GetUserFunctionalityList',
        GetUserOrganizationRoleList: UserUrl + 'GetUserOrganizationRoleList',
        SetDefaultUserOrganization: UserUrl + 'SetDefaultUserOrganization',
        RemoveUserOrganization: UserUrl + 'RemoveUserOrganization',
        RemoveUserOrganizationRole: UserUrl + 'RemoveUserOrganizationRole',
        AddUserOrganization: UserUrl + 'AddUserOrganization',
        AddUserOrganizationRole: UserUrl + 'AddUserOrganizationRole',
    },
    BizParamSetting: {
        GetBizParamSettingList: BizParamSettingUrl + 'GetBizParamSettingList',
    },
    CodeFormat: {
        GetCodeFormatList: CodeFormatUrl + 'GetCodeFormatList',
        SaveCodeFormat: CodeFormatUrl + 'SaveCodeFormat',
        MoveUpCodeFormat: CodeFormatUrl + 'MoveUpCodeFormat',
        MoveDownCodeFormat: CodeFormatUrl + 'MoveDownCodeFormat',
        GetCodeFormatTypeOptions: CodeFormatUrl + 'GetCodeFormatTypeOptions',
    },
    Company: {
        GetCompanyList: CompanyUrl + 'GetCompanyList',
        GetCompany: CompanyUrl + 'GetCompany',
        SaveCompany: CompanyUrl + 'SaveCompany',
        DeleteCompany: CompanyUrl + 'DeleteCompany',
        SetActiveCompany: CompanyUrl + 'SetActiveCompany',
        GetCompanyOptions: CompanyUrl + 'GetCompanyOptions',
    },
    BlackList: {
        GetBlackListList: BlackListUrl + 'GetBlackListList',
        GetBlackList: BlackListUrl + 'GetBlackList',
        SaveBlackList: BlackListUrl + 'SaveBlackList',
        DeleteBlackList: BlackListUrl + 'DeleteBlackList',
        SetActiveBlackList: BlackListUrl + 'SetActiveBlackList',
        GetCompanyOptions: CompanyUrl + 'GetCompanyOptions',
    },
    ProductMerge: {
        GetProductMergeList: ProductMergeUrl + 'GetProductMergeList',
        GetProductMerge: ProductMergeUrl + 'GetProductMerge',
        SaveProductMerge: ProductMergeUrl + 'SaveProductMerge',
        DeleteProductMerge: ProductMergeUrl + 'DeleteProductMerge',
        ActiveProductMerge: ProductMergeUrl + 'ActiveProductMerge',
        GetCompanyOptions: CompanyUrl + 'GetCompanyOptions',
    },
    AttributeRule: {
        GetAttributeRuleList: AttributeRuleUrl + 'GetAttributeRuleList',
        GetAttributeRule: AttributeRuleUrl + 'GetAttributeRule',
        SaveAttributeRule: AttributeRuleUrl + 'SaveAttributeRule',
        DeleteAttributeRule: AttributeRuleUrl + 'DeleteAttributeRule',
        SetActiveAttributeRuleDetail: AttributeRuleUrl + 'SetActiveAttributeRuleDetail',
        GetAttributeRuleDetailList: AttributeRuleUrl + 'GetAttributeRuleDetailList',
        GetAttributeRuleDetail: AttributeRuleUrl + 'GetAttributeRuleDetail',
        SaveAttributeRuleDetail: AttributeRuleUrl + 'SaveAttributeRuleDetail',
        MoveUpAttributeRuleDetail: AttributeRuleUrl + 'MoveUpAttributeRuleDetail',
        MoveDownAttributeRuleDetail: AttributeRuleUrl + 'MoveDownAttributeRuleDetail',
        GetAttributeRuleDetailByType: AttributeRuleUrl + 'GetAttributeRuleDetailByType',
    },
    Customer: {
        GetCustomerList: CustomerUrl + 'GetCustomerList',
        GetCustomer: CustomerUrl + 'GetCustomer',
        SaveCustomer: CustomerUrl + 'SaveCustomer',
        DeleteCustomer: CustomerUrl + 'DeleteCustomer',
        SetActiveCustomer: CustomerUrl + 'SetActiveCustomer',
        GetCustomerOptions: CustomerUrl + 'GetCustomerOptions',
    },
    Sales: {
        GetSalesList: SalesUrl + 'GetSalesList',
        GetSales: SalesUrl + 'GetSales',
        SaveSales: SalesUrl + 'SaveSales',
        DeleteSales: SalesUrl + 'DeleteSales',
        SetActiveSales: SalesUrl + 'SetActiveSales',
        GetSalesOptions: SalesUrl + 'GetSalesOptions',
    },
    Vendor: {
        GetVendorList: VendorUrl + 'GetVendorList',
        GetVendor: VendorUrl + 'GetVendor',
        SaveVendor: VendorUrl + 'SaveVendor',
        DeleteVendor: VendorUrl + 'DeleteVendor',
        SetActiveVendor: VendorUrl + 'SetActiveVendor',
        SetOnlineVendor: VendorUrl + 'SetOnlineVendor',
        GetVendorOptions: VendorUrl + 'GetVendorOptions',
    },
    Product: {
        GetProductList: ProductUrl + 'GetProductList',
        GetProduct: ProductUrl + 'GetProduct',
        SaveProduct: ProductUrl + 'SaveProduct',
        DeleteProduct: ProductUrl + 'DeleteProduct',
        SetActiveProduct: ProductUrl + 'SetActiveProduct',
        GetScopeOptions: ProductUrl + 'GetScopeOptions',
        GetProductTypeOptions: ProductUrl + 'GetProductTypeOptions',
        GetTypeOptions: ProductUrl + 'GetTypeOptions',
        GetProductCompanyList: ProductUrl + 'GetProductCompanyList',
        GetProductAddition: ProductUrl + 'GetProductAddition',
        SaveProductAddition: ProductUrl + 'SaveProductAddition'
    },
    ApplyProduct: {
        GetApplyProductList: ApplyProductUrl + 'GetApplyProductList',
        GetApplyProduct: ApplyProductUrl + 'GetApplyProduct',
        SaveApplyProduct: ApplyProductUrl + 'SaveApplyProduct',
        DeleteApplyProduct: ApplyProductUrl + 'DeleteApplyProduct',
        SetActiveApplyProduct: ApplyProductUrl + 'SetActiveApplyProduct',
        GetApplyProductOptions: ApplyProductUrl + 'GetApplyProductOptions',
    },
    ComparisonProduct: {
        GetComparisonProductList: ComparisonProductUrl + 'GetComparisonProductList',
        GetComparisonProduct: ComparisonProductUrl + 'GetComparisonProduct',
        SaveComparisonProduct: ComparisonProductUrl + 'SaveComparisonProduct',
        DeleteComparisonProduct: ComparisonProductUrl + 'DeleteComparisonProduct',
        SetActiveComparisonProduct: ComparisonProductUrl + 'SetActiveComparisonProduct',
        SetOnlineComparisonProduct: ComparisonProductUrl + 'SetOnlineComparisonProduct',
        GetComparisonProductOptions: ComparisonProductUrl + 'GetComparisonProductOptions',
    },
    Account: {
        GetAccountList: AccountUrl + 'GetAccountList',
        GetAccount: AccountUrl + 'GetAccount',
        CreateAccount: AccountUrl + 'CreateAccount',
        GetAccountRechargeList: AccountUrl + 'GetAccountRechargeList',
        RechargeAccount: AccountUrl + 'RechargeAccount',
        GetAccountConsumptionList: AccountUrl + 'GetAccountConsumptionList',
    },
    OnlineVendor: {
        GetVendorList: OnlineVendorUrl + 'GetVendorList',
        SetOnlineVendor: OnlineVendorUrl + 'SetOnlineVendor',
    },
    OnlineProduct: {
        GetProductList: OnlineProductUrl + 'GetProductList',
        SetOnlineProduct: OnlineProductUrl + 'SetOnlineProduct',
        SetHotProduct: OnlineProductUrl + 'SetHotProduct',
    },
    Agent: {
        GetAgentList: AgentUrl + 'GetAgentList',
        BindAgent: AgentUrl + 'BindAgent',
        UnBindAgent: AgentUrl + 'UnBindAgent',
        RechargeAgent: AgentUrl + 'RechargeAgent',
        GetAgentRateList: AgentUrl + 'GetAgentRateList',
        SaveAgentRate: AgentUrl + 'SaveAgentRate',
    },
    Member: {
        GetMemberList: MemberUrl + 'GetMemberList',
        AddMember: MemberUrl + 'AddMember',
        SetActiveMember: MemberUrl + 'SetActiveMember',
        GetMemberAccount: MemberUrl + 'GetMemberAccount',
    },
    OnlineOrder: {
        GetOnlineOrderList: OnlineOrderUrl + 'GetOnlineOrderList',
    },
    ApplyAllocation: {
        GetApplyAllocationList: ApplyAllocationUrl + 'GetApplyAllocationList',
        GetApplyAllocation: ApplyAllocationUrl + 'GetApplyAllocation',
        GetApplyAllocationAmount: ApplyAllocationUrl + 'GetApplyAllocationAmount',
        AddApplyAllocation: ApplyAllocationUrl + 'AddApplyAllocation',
        RechargeApplyAllocation: ApplyAllocationUrl + 'RechargeApplyAllocation',
    },
    ApplyOrder: {
        GetApplyOrderList: ApplyOrderUrl + 'GetApplyOrderList',
        GetApplyOrder: ApplyOrderUrl + 'GetApplyOrder',
        AddApplyOrder: ApplyOrderUrl + 'AddApplyOrder',
        RechargeApplyOrder: ApplyOrderUrl + 'RechargeApplyOrder',
        GetAllocationApplyOrderList: ApplyOrderUrl + 'GetAllocationApplyOrderList',
    },
    ApplyMember: {
        GetApplyMemberList: ApplyMemberUrl + 'GetApplyMemberList',
        SearchApplyMember: ApplyMemberUrl + 'SearchApplyMember',
        SetActiveApplyMember: ApplyMemberUrl + 'SetActiveApplyMember',
        AddMember: ApplyMemberUrl + 'AddMember',
    },
    ApplyConsume: {
        GetApplyConsumeList: ApplyConsumeUrl + 'GetApplyConsumeList',
    },
    ApplyEmail: {
        GetApplyEmailList: ApplyEmailUrl + 'GetApplyEmailList',
    },
    YearOrder: {
        GetYearOrderList: YearOrderUrl + 'GetYearOrderList',
        GetYearOrder: YearOrderUrl + 'GetYearOrder',
        SaveYearOrder: YearOrderUrl + 'SaveYearOrder',
        DeleteYearOrder: YearOrderUrl + 'DeleteYearOrder',
        GetYearOrderCount: YearOrderUrl + 'GetYearOrderCount',
        GetYearOrderSalesReport: YearOrderUrl + 'GetYearOrderSalesReport',
        GetYearOrderCompanyReport: YearOrderUrl + 'GetYearOrderCompanyReport',
        GetYearOrderReport: YearOrderUrl + 'GetYearOrderReport',
    },
    YearOrderSettle: {
        GetYearOrderSettleList: YearOrderSettleUrl + 'GetYearOrderSettleList',
        SettleVendor: YearOrderSettleUrl + 'SettleVendor',
        SettleSales: YearOrderSettleUrl + 'SettleSales'
    },
    InquiryOrder: {
        GetInquiryOrderList: InquiryOrderUrl + 'GetInquiryOrderList',
        GetInquiryOrder: InquiryOrderUrl + 'GetInquiryOrder',
        SaveInquiryOrder: InquiryOrderUrl + 'SaveInquiryOrder',
        DeleteInquiryOrder: InquiryOrderUrl + 'DeleteInquiryOrder',
        ExportInquiryOrder: InquiryOrderUrl + 'ExportInquiryOrder',
        GetInquiryRecord: InquiryOrderUrl + 'GetInquiryRecord',
        SaveInquiryRecord: InquiryOrderUrl + 'SaveInquiryRecord',
        DeleteInquiryRecord: InquiryOrderUrl + 'DeleteInquiryRecord',
    },
    InquiryMember: {
        GetInquiryMemberList: InquiryMemberUrl + 'GetInquiryMemberList',
        SearchInquiryMember: InquiryMemberUrl + 'SearchInquiryMember',
        GetInquiryMember: InquiryMemberUrl + 'GetInquiryMember',
        SetActiveInquiryMember: InquiryMemberUrl + 'SetActiveInquiryMember',
        SaveInquiryMember: InquiryMemberUrl + 'SaveInquiryMember',
        UnBindWXInquiryMember: InquiryMemberUrl + 'UnBindWXInquiryMember',
    },
    ComparisonMember: {
        GetComparisonMemberList: ComparisonMemberUrl + 'GetComparisonMemberList',
        GetComparisonMember: ComparisonMemberUrl + 'GetComparisonMember',
        AddMember: ComparisonMemberUrl + 'AddMember',
        SetActiveComparisonMember: ComparisonMemberUrl + 'SetActiveComparisonMember',
        BindSalesComparisonMember: ComparisonMemberUrl + 'BindSalesComparisonMember',
        UnBindSalesComparisonMember: ComparisonMemberUrl + 'UnBindSalesComparisonMember',
        UpdateMemberName: ComparisonMemberUrl + 'UpdateMemberName',
    },
    OnlineComparisonProduct: {
        GetOnlineComparisonProductList: OnlineComparisonProductUrl + 'GetOnlineComparisonProductList',
        SetOnlineComparisonProduct: OnlineComparisonProductUrl + 'SetOnlineComparisonProduct',
    },
    ComparisonProductNotice: {
        GetComparisonProductNoticeList: ComparisonProductNoticeUrl + 'GetComparisonProductNoticeList',
        GetComparisonProductNotice: ComparisonProductNoticeUrl + 'GetComparisonProductNotice',
        SaveComparisonProductNotice: ComparisonProductNoticeUrl + 'SaveComparisonProductNotice',
        DeleteComparisonProductNotice: ComparisonProductNoticeUrl + 'DeleteComparisonProductNotice',
        SetOnlineComparisonProductNotice: ComparisonProductNoticeUrl + 'SetOnlineComparisonProductNotice',
    }
};
export default URL;